module.exports = __webpack_public_path__ + "img/companylogo2.fd985983.png";